import { http } from '@/http/index'

async function publishPaidMessage(threadId, paidMessageId) {
	return http.post(`/paid-messages/${paidMessageId}/threads/${threadId}/publish`).then((response) => response.data)
}

export { publishPaidMessage }
